import { Box, Checkbox, MenuItem, Select, TableCell, TableRow } from '@mui/material';
import React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import { TooltipItem } from '../../../../components/TooltipItem/TooltipItem';
import { getControlledText } from '../../../enum/GenericFormat';
import defaultLumns from '../../../../assets/images/default_luminaire_image.png';
import { WirelessLumTestGroupFilterDropdownItems } from '../../../enum/ENUM';
import { useLanguageLocale } from '../../../../hooks/language-locale-hooks';
import { zoneArray } from '../LuminariesConfiguration/ConfigureLumnListItems';

type Props = {
    row: any
    selected: string[]
    onSelectRow: (event: React.ChangeEvent<HTMLInputElement>, id: string) => void
}

const TestGroupTableListItems: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props: Props) => {
    const { row, selected, onSelectRow } = props;
    const testGroupDropdownItems = WirelessLumTestGroupFilterDropdownItems;
    const [localZone, setLocalZone] = React.useState(row.zone);
    const [testgroup, setTestgroup] = React.useState(row.testGroupId);

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>, id: string) => {
        onSelectRow(event, id);
    };

    return (
        <>
            <TableRow
                id={`row${row.id}`}
                data-testid={`row${row.id}`}
                style={{ cursor: 'pointer', width: '120%', marginTop: 5, paddingTop: 10, backgroundColor: PXBColors.white[100] }}>
                <TableCell></TableCell>
                <TableCell sx={{ pl: 0, width: 36 }}>
                    <Checkbox
                        color="primary"
                        checked={selected.includes(row.id)}
                        onChange={(event) => handleSelect(event, row.id)}
                        sx={{ p: 0, m: 0 }}
                        inputProps={{
                            'aria-label': 'select this row',
                        }}
                    />
                </TableCell>
                <TableCell style={{ width: '12%',paddingRight:'1%' }}
                    padding='none' data-testid="config-lums-list-zone-name">
                    <Select
                        value={localZone}
                        onChange={(e) => {
                            setLocalZone(e.target.value);
                        }}
                        variant="outlined"
                        disableUnderline
                        fullWidth
                        displayEmpty
                        inputProps={{ 'aria-label': 'Zone' }}
                        MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}

                    >
                        {zoneArray.map((zone) => (
                            <MenuItem key={zone.id} value={zone.id}>
                                {zone.id}. {zone.zone}
                            </MenuItem>
                        ))}
                    </Select>

                </TableCell>
                <TooltipItem title={row.name} isTopPlacement={true} lenghtLimit={15} component={<TableCell
                    id="config-lums-list-lumns-name"
                    data-testid="config-lums-list-lumns-name"
                    align="left"
                    padding="none"
                    style={{ width: '12%', wordWrap: 'break-word', wordBreak: 'break-all', }}
                >
                    {getControlledText(row.name, 15)}
                </TableCell>}></TooltipItem>
                <TableCell align='center' id="config-lums-list-epas" data-testid="config-lums-list-epas"  padding="none" style={{ width: '8%' }}>
                    {row.epasNumber ? row.epasNumber : '-'}
                </TableCell>
                <TableCell id="config-lums-list-product-family" data-testid="config-lums-list-product-family" align="left" padding="none" style={{ width: '15%' }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        alignItems: 'center',
                        gap: 1,
                    }}>
                        <img
                            id="lumns-image"
                            data-testid="lumns-image"
                            src={row.epasProductImgUrl ? row.epasProductImgUrl : defaultLumns}
                            alt={"image"}
                            style={{ width: 50, height: 50, borderRadius: '50%', marginTop: '5%', marginBottom: '5%', backgroundSize: 'contain', backgroundPosition: 'center' }}
                        />
                        {row.productFamily ? row.productFamily : '-'}
                    </Box>
                </TableCell>
                <TableCell id="config-lums-list-category" align='center' data-testid="config-lums-list-category"  padding="none" style={{ width: '10%' }}>
                    {row.category ? row.category : '-'}
                </TableCell>
                <TableCell align='left' id="config-lums-list-partNo" data-testid="config-lums-list-partNo" style={{ width: '10%' }}>
                    {row.lumPartNumber ? row.lumPartNumber : '-'}
                </TableCell>
                <TableCell
                    id="config-lums-list-test-group"
                    data-testid="config-lums-list-test-group"
                    padding="none"
                    style={{ width: '8%' }}
                >
                    <Select
                        value={testgroup}
                        variant="outlined"
                        disableUnderline
                        fullWidth
                        displayEmpty
                        onChange={(e) => {
                            setTestgroup(e.target.value);
                        }}
                        inputProps={{ 'aria-label': 'Test Group' }}
                        MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
                    // Show error state
                    >
                        {testGroupDropdownItems.map((group) => (
                            <MenuItem key={group} value={group}>
                                {group}
                            </MenuItem>
                        ))}
                    </Select>
                </TableCell>
                <TableCell align='left' id="config-lums-list-rated-duration" data-testid="config-lums-list-rated-duration" style={{ width: '10%' }}>
                    {row.ratedDuration}
                </TableCell>
                <TooltipItem title={row.description} isTopPlacement={true} lenghtLimit={15} component={<TableCell
                    id="config-lums-list-optional-desc"
                    data-testid="config-lums-list-optional-desc"
                    align="left"
                    padding="checkbox"
                    style={{ width: '10%', wordWrap: 'break-word', wordBreak: 'break-all' }}
                >
                    {getControlledText(row.description, 15)}
                </TableCell>}></TooltipItem>
                {/* <TableCell id="config-lums-list-icons" data-testid="config-lums-list-product-icons" align="center" padding="none">
                    <Box style={{ display: 'flex', gap: 2, }}>
                        <IconButton id="config-lumn-delete-icon">
                            <DeleteOutlineIcon />
                        </IconButton>
                        <IconButton id="config-lumn-equal-icon">
                            <DensityMediumOutlinedIcon />
                        </IconButton>
                    </Box>
                </TableCell> */}
            </TableRow>
        </>
    )
}

export default TestGroupTableListItems
